export * from '@primeuix/themes/nora/terminal';
export { default } from '@primeuix/themes/nora/terminal';
